<template>
	<BaseModal
		:show="isOpen"
		:rounded="whitelabel?.styles?.bg?.borderRadius"
		:class="partnerClass"
		class="relative z-10"
		@close="onClose"
	>
		<template #title>
			<div class="mt-4 text-left text-xl font-semibold text-gray-900">
				Incomplete order
			</div>
		</template>

		<template #content>
			<div class="mt-4">
				<p class="text-md">
					We found a subscription order in progress. Do you wish to
					resume the existing order or start a new order?
				</p>
			</div>

			<div class="mt-8 space-y-2 text-center">
				<CarbarButton
					:rounded="whitelabel?.styles?.button?.borderRadius"
					:background-color="whitelabel?.styles?.button?.bg"
					:disabled="isStartingOrder || isResumingOrder"
					:show-loader="isStartingOrder"
					@click="onStartNew"
				>
					Start new
				</CarbarButton>
				<CarbarButton
					:rounded="whitelabel?.styles?.button?.borderRadius"
					:background-color="whitelabel?.styles?.button?.bg"
					:disabled="isResumingOrder || isStartingOrder"
					:show-loader="isResumingOrder"
					:is-outline="true"
					:is-mixed="true"
					border-color="disabled:border-gray-300"
					@click="onResume"
				>
					Resume existing
				</CarbarButton>
			</div>
		</template>
	</BaseModal>
</template>

<script setup>
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import BaseModal from '@/components/modals/BaseModal.vue'

const props = defineProps({
	isOpen: {
		type: Boolean,
		required: true,
	},
	isResumingOrder: {
		type: Boolean,
		default: false,
	},
	isStartingOrder: {
		type: Boolean,
		default: false,
	},
})

const { whitelabel } = useWhitelabelsStyles()
const { partnerName } = useGetPartnerName()

const partnerClass = computed(() => {
	return partnerName.value === 'carsales' ? 'carsales' : ''
})

const emit = defineEmits(['close', 'resumeOrder', 'startNewOrder'])

function onClose() {
	emit('close')
}
function onResume() {
	emit('resumeOrder')
}
function onStartNew() {
	emit('startNewOrder')
}
</script>
